import { generateClient, GraphQLResult } from "aws-amplify/api";
import { ProjectForResolver, UserForResolver } from "db/definitions";
import { recordSentry } from "utils/recordSentry";
import { getProjects } from "../db/queries/projectQueries";
// @ts-ignore
import { listProjects } from "../graphql/queries";

async function _getProjects(online: boolean, user: UserForResolver): Promise<ProjectForResolver[]> {
	try {
		if (online) {
			const previousItems: ProjectForResolver[] = [];
			const projects = await getBatch(previousItems);
			return projects;
		} else {
			const projects = await getProjects();
			const finalProjects = projects.filter((proj) => {
				if (user.group === "FactorEarth") return proj;
				return proj.group === user.group;
			});
			return finalProjects;
		}
	} catch (error) {
		recordSentry({ error, msg: "ERROR getting projects: " });
	}
	return [];
}

async function getBatch(previousItems: ProjectForResolver[]): Promise<ProjectForResolver[]> {
	interface QueryResponse {
		listProjects: {
			items: ProjectForResolver[];
			nextToken?: string;
		};
	}
	let nextToken;
	while (nextToken !== null) {
		const token = nextToken ? nextToken : null;
		const client = generateClient({ authMode: "userPool" });
		const projects = (await client.graphql({
			query: listProjects,
			authMode: "userPool",
			variables: {
				nextToken: token,
			},
		})) as GraphQLResult<QueryResponse>;
		const projectArray = projects.data.listProjects.items;
		for (const project of projectArray) {
			previousItems.push(project);
		}
		nextToken = projects.data.listProjects.nextToken;
	}
	return previousItems;
}

export default _getProjects;
